export default __webpack_public_path__ + "static/media/logo-green-travel.23e9c090.png";